import React from 'react'
import { Query, Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import Select from 'react-select'

import format from 'date-fns/format'
import omit from 'lodash/omit'

import { Table, Header, Button } from 'semantic-ui-react'
import { Dialog } from '@reach/dialog'

const SCS_STATE_OPTIONS = [
  { value: 'eligible', label: 'Eligible' },
  { value: 'qualified', label: 'Qualified' },
  { value: 'transitioned', label: 'Transitioned' },
  { value: 'disqualified', label: 'Disqualified' },
  { value: 'nurture', label: 'Nurture' },
  { value: 'contact', label: 'Contact' },
]

class UpdateScsStateDialog extends React.Component {
  state = {
    scsStateOption: this.props.initialScsStateOption,
  }

  render() {
    const { isOpen, focusedUserId, closeDialog, refetchQueries } = this.props
    return (
      <Dialog isOpen={isOpen}>
        <Button style={{ float: 'right' }} onClick={closeDialog}>
          Close
        </Button>
        <p>{`Update user SCS state for ${focusedUserId}?`}</p>
        <Select
          name="userScsState"
          isSearchable={false}
          isClearable={false}
          options={SCS_STATE_OPTIONS}
          value={this.state.scsStateOption}
          getOptionLabel={option => option.label}
          onChange={scsStateOption => this.setState({ scsStateOption })}
        />

        <div style={{ textAlign: 'center', marginTop: 12 }}>
          <Mutation mutation={SET_SCS_STATE} refetchQueries={refetchQueries}>
            {(setScsState, { loading }) => {
              return (
                <Button
                  loading={loading}
                  primary
                  onClick={() => {
                    setScsState({
                      variables: {
                        id: focusedUserId,
                        scsState: this.state.scsStateOption.value,
                      },
                    }).then(closeDialog)
                  }}
                >
                  Update
                </Button>
              )
            }}
          </Mutation>
        </div>
      </Dialog>
    )
  }
}

class ScsManagement extends React.Component {
  state = {
    limit: 9999,
    startTime: 0,
    endTime: Date.now(),
    scsStateOption: SCS_STATE_OPTIONS[0],
    focusedUserId: '',
    showUpdateScsStateDialog: false,
  }

  openDialog = id => () =>
    this.setState({ showUpdateScsStateDialog: true, focusedUserId: id })

  closeDialog = () =>
    this.setState({ showUpdateScsStateDialog: false, focusedUserId: '' })

  renderRow = ({
    id,
    email,
    scsState,
    firstName,
    lastName,
    scsChanged,
    scsContactCount,
  }) => {
    return (
      <Table.Row key={id}>
        <Table.Cell>{email}</Table.Cell>
        <Table.Cell>{`${firstName} ${lastName}`}</Table.Cell>
        <Table.Cell selectable>
          <Button basic onClick={this.openDialog(id)}>
            {scsState}
          </Button>
        </Table.Cell>
        <Table.Cell>{format(scsChanged, 'MM/DD h:mm a')}</Table.Cell>
        <Table.Cell>{scsContactCount}</Table.Cell>
      </Table.Row>
    )
  }

  renderTable = data => {
    return (
      <Table celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>SCS State</Table.HeaderCell>
            <Table.HeaderCell>Last State Update</Table.HeaderCell>
            <Table.HeaderCell>Update Count</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{data.listCandidates.map(this.renderRow)}</Table.Body>
      </Table>
    )
  }
  render() {
    const {
      scsStateOption,
      focusedUserId,
      showUpdateScsStateDialog,
    } = this.state
    const variables = omit(this.state, ['scsStateOption'])
    variables.scsState = scsStateOption.value

    return (
      <React.Fragment>
        <Header as="h2" content="SCS Candidate Managment" />
        <label htmlFor="scsState">SCS State Filter</label>
        <Select
          name="scsState"
          isSearchable={false}
          isClearable={false}
          options={SCS_STATE_OPTIONS}
          value={scsStateOption}
          getOptionLabel={option => option.label}
          onChange={scsStateOption => this.setState({ scsStateOption })}
        />

        <Query query={LIST_CANDIDATES} variables={variables}>
          {({ data, loading, error, refetch }) => {
            if (loading) {
              return <div>loading...</div>
            }

            if (error) {
              console.error(error)
              return <div>An error occurred</div>
            }

            return (
              <React.Fragment>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 12,
                  }}
                >
                  <p>Click the SCS State for a user to launch update dialog</p>
                  <Button onClick={() => refetch({ variables })}>
                    Refetch
                  </Button>
                </div>
                {this.renderTable(data)}
              </React.Fragment>
            )
          }}
        </Query>

        <UpdateScsStateDialog
          isOpen={showUpdateScsStateDialog}
          closeDialog={this.closeDialog}
          focusedUserId={focusedUserId}
          initialScsStateOption={scsStateOption}
          refetchQueries={[{ query: LIST_CANDIDATES, variables }]}
        />
      </React.Fragment>
    )
  }
}

const LIST_CANDIDATES = gql`
  query ListCandidates(
    $limit: Int
    $startTime: Float
    $endTime: Float
    $scsState: String!
  ) {
    listCandidates(
      limit: $limit
      startTime: $startTime
      endTime: $endTime
      scsState: $scsState
    ) {
      id
      email
      firstName
      lastName
      scsState
      scsChanged
      scsContactCount
    }
  }
`

const SET_SCS_STATE = gql`
  mutation SetScsState($id: ID!, $scsState: String!) {
    setScsState(id: $id, scsState: $scsState) {
      id
      email
      firstName
      lastName
      scsState
      scsChanged
      scsContactCount
    }
  }
`

export default ScsManagement
